var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 52.5C46.2375 52.5 26.25 57.4875 26.25 67.5V75H86.25V67.5C86.25 57.4875 66.2625 52.5 56.25 52.5ZM22.5 37.5V26.25H15V37.5H3.75V45H15V56.25H22.5V45H33.75V37.5M56.25 45C60.2282 45 64.0436 43.4196 66.8566 40.6066C69.6696 37.7936 71.25 33.9782 71.25 30C71.25 26.0218 69.6696 22.2064 66.8566 19.3934C64.0436 16.5804 60.2282 15 56.25 15C52.2718 15 48.4564 16.5804 45.6434 19.3934C42.8304 22.2064 41.25 26.0218 41.25 30C41.25 33.9782 42.8304 37.7936 45.6434 40.6066C48.4564 43.4196 52.2718 45 56.25 45Z",
    fill: "#E7836E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiRegister);
export default __webpack_public_path__ + "static/media/mdi_register.a947d3d7775472c4a8c8ad97de964dbd.svg";
export { ForwardRef as ReactComponent };